// Modules
import { Children, useEffect, useRef, } from 'react';
import cn from 'classnames';

// Types
import type { CSSProperties, JSX } from 'react';
import type { TTabPanelListProps } from './Tabs.type';

// Styles
import styles from './styles/styles.module.scss';

// Components
import { TabPanel } from './index';

// Constants
import { TAB_PANEL_DISPLAY_NAME, TAB_PANEL_LIST_DEFAULT_PROPS, TAB_PANEL_SLIDE_DIRECTION } from './Tab.constant';

const TabPanelList = (props: TTabPanelListProps) => {
	const {
		activePanel = TAB_PANEL_LIST_DEFAULT_PROPS.activePanel,
		className,
		children,
		...restProps
	} = props;
	const prevActivePanel = useRef<number>(activePanel!);
	const slideInDirection = prevActivePanel.current < activePanel! ?
		TAB_PANEL_SLIDE_DIRECTION.right :
		TAB_PANEL_SLIDE_DIRECTION.left;
	const slideOutDirection = prevActivePanel.current < activePanel! ?
		TAB_PANEL_SLIDE_DIRECTION.left :
		TAB_PANEL_SLIDE_DIRECTION.right;
	const tabPanelListCN = cn(styles.legion_tab_panel_list, className);

	useEffect(() => {
		prevActivePanel.current = activePanel!;
	}, [activePanel]);

	return (
		<div className={tabPanelListCN} {...restProps}>
			{
				// Filter out children that are not `TabPanel` components
				Children.toArray(children).filter(child => (child as JSX.Element)?.type?.displayName === TAB_PANEL_DISPLAY_NAME).map((child, childIndex) => {
					const { key, ...restProps } = (child as JSX.Element).props;

					const childProps = {
						...restProps,
						style: {
							...restProps.style,
							position: activePanel === childIndex ? 'relative' : 'absolute',
						} as CSSProperties,
						slideDirection: activePanel === childIndex ? slideInDirection : slideOutDirection,
						active: activePanel === childIndex
					};

					return (
						<TabPanel key={key} {...childProps} />
					)
				})
			}
		</div>
	);
}

export default TabPanelList;
